var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinesHorizontalLongBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Decorative Elements (Front)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Decorative Lines",
    fill: "none",
    stroke: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.5 24V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line",
    d: "M120.5 24V0m-12 24V0m-12 24V0m-12 24V0m-12 24V0m-12 24V0m-12 24V0m-12 24V0m-12 24V0m-12 24V0M.5 24V0"
  })))));
}
export default "/_next/static/assets/public/graphics/clearing/939f9db27649471c8c5850f08ad1cf05.svg";
export { SvgLinesHorizontalLongBlack as ReactComponent };